import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot, CanActivate } from '@angular/router';
import { Observable } from 'rxjs';

import { GlobalService } from '../services/global.service';

@Injectable()
export class AuthGuard implements CanActivate {
  public path: ActivatedRouteSnapshot[];
  public route: ActivatedRouteSnapshot;

  constructor(private _glService: GlobalService, private _router: Router) {}

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean  {
    if (!this._glService.isUserAuthenticated()) {
      this._router.navigateByUrl('login');
    }
    return true;
  }
}
